import { coreTimelineSummaryGetAsyncSlice } from './get';

export const { requestGetCoreTimelineSummary, resetGetCoreTimelineSummary } =
	coreTimelineSummaryGetAsyncSlice.asyncActionCreators;
